export const BASE_URL: string = "https://dev.vws-api.voithrucorp.com/"; // dev_server "http://10.10.124.57:8080"//

// export const INSPECTION_URL: string = "http://jamake-inspection-api-dev.ap-northeast-2.elasticbeanstalk.com/"; // inspection dev_server

// export const LOGGER_BASE_URL = "https://dev.api.logger.jamake.io/";
